import { RouteLocationNormalized } from 'vue-router';
import { useModelsStore } from '~/stores';

class ServerInstalled implements Middleware {
    name() {
        return 'server_installed';
    }

    async run(to: RouteLocationNormalized) {
        const modelsStore = useModelsStore();
        const server = modelsStore.server;

        // If no server is loaded, let the request continue
        if (!server) {
            return;
        }

        // Lock the UI to console-only when the server is mid-install or mid-transfer.
        if (server.isLocked) {
            // Check if the route explicitly allows access while locked
            const allowWhenInstalling = to.meta?.allowWhenInstalling === true;

            // Allow access to console and main server page while locked.
            const allowedRoutes = ['server.console', 'server.system.index', 'server.configuration.importer'];

            // Allow if route has allowWhenInstalling flag
            if (allowWhenInstalling) {
                return;
            }

            // Allow console access while locked
            if (allowedRoutes.includes(to.name as string)) {
                return;
            }

            // Redirect to console page if trying to access other pages while locked
            if (!allowedRoutes.includes(to.name as string)) {
                return {
                    name: 'server.console',
                    params: to.params,
                };
            }
        }
    }
}

export default new ServerInstalled();
